import React from 'react';
import '../../../styles/modes/setupMode.css';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Setup Points Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> This is the first step in solving Transportation Problems (TP). Set up supply and demand location points for optimal allocation analysis.</p>
          
          <p><strong>Three Ways to Add Points:</strong></p>
          
          <p><strong>Method 1: Map Point Marking</strong></p>
          <ol>
            <li>Toggle between "Add: Supply" and "Add: Demand"</li>
            <li>Enter default quantity in the input field</li>
            <li>Click on the map to add points at desired locations</li>
            <li>Each click adds a point with the default quantity</li>
            <li>Supply points appear in green, Demand points in blue</li>
          </ol>

          <p><strong>Method 2: Manual Input (CSV Text)</strong></p>
          <ol>
            <li>Click "Manual Input" tab</li>
            <li>Paste CSV rows directly into text area</li>
            <li>Format: Number,Type,Quantity,Address,Latitude,Longitude</li>
            <li>Click "Add from Text" to import</li>
            <li>No file needed - quick for small datasets</li>
          </ol>

          <p><strong>Method 3: Load Points (CSV File)</strong></p>
          <ol>
            <li>Click "Load Points" tab</li>
            <li>Prepare CSV file with required format</li>
            <li>Click "Upload CSV File" button</li>
            <li>Select your prepared CSV file</li>
            <li>System automatically imports and validates all points</li>
            <li>Download example CSV for reference</li>
          </ol>

          <p><strong>Manage Points:</strong></p>
          <ul>
            <li>View all points in Location Points list</li>
            <li>Supply points shown in green, Demand in blue</li>
            <li>Edit quantities by clicking on them</li>
            <li>Delete points using × button</li>
            <li>Download current configuration as CSV</li>
            <li>Reset to clear all points</li>
          </ul>

          <p><strong>CSV File Format:</strong></p>
          <ul>
            <li><strong>Number:</strong> Sequential identifier (1, 2, 3...)</li>
            <li><strong>Type:</strong> "Supply" or "Demand" (case-insensitive)</li>
            <li><strong>Quantity:</strong> Supply capacity or demand requirement (positive number)</li>
            <li><strong>Address:</strong> Location description or name</li>
            <li><strong>Latitude:</strong> Geographic latitude (-90 to 90)</li>
            <li><strong>Longitude:</strong> Geographic longitude (-180 to 180)</li>
          </ul>

          <p><strong>Complete TP Workflow:</strong></p>
          <ol>
            <li><strong>Step 1: Setup Points (Current)</strong>
              <ul>
                <li>Import supply and demand locations from CSV</li>
                <li>Verify all points are correctly loaded</li>
              </ul>
            </li>
            <li><strong>Step 2a: Auto Path Mode</strong>
              <ul>
                <li>Calculate distance matrix automatically</li>
                <li>Use algorithms to solve optimal allocation</li>
                <li>View allocation matrix and total cost</li>
              </ul>
            </li>
            <li><strong>Step 2b: Custom Path Mode</strong>
              <ul>
                <li>Manually create allocation plan</li>
                <li>Set quantity for each supply-demand pair</li>
                <li>Design based on domain knowledge</li>
              </ul>
            </li>
            <li><strong>Step 3: Compare Mode</strong>
              <ul>
                <li>Compare auto vs manual allocations</li>
                <li>Analyze cost differences and efficiency</li>
              </ul>
            </li>
          </ol>

          <p><strong>Validation Rules:</strong></p>
          <ul>
            <li>Latitude must be between -90 and 90 degrees</li>
            <li>Longitude must be between -180 and 180 degrees</li>
            <li>Quantity must be a positive number</li>
            <li>Type must be exactly "Supply" or "Demand"</li>
            <li>At least one supply and one demand point required</li>
            <li>Invalid rows will be skipped with warnings</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Download the example CSV file to see correct format</li>
            <li>Keep total supply ≥ total demand for feasible solutions</li>
            <li>Use descriptive addresses for easy identification</li>
            <li>Save your configuration regularly by downloading</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 